<template>
  <div>
    <div class="bj dis-cent">
      <div class="content">
        <div class="headBox">
          <div class="name">填写你要更换的公司全称</div>
          <div class="iconfont icon-close close" @click="delClick"></div>
        </div>
        <div class="inpBox">
          <a-select
            size="large"
            show-search
            placeholder="请输入营业执照上的公司名称"
            option-filter-prop="children"
            style="width: 100%; height: 35px"
            v-model="value"
            :filter-option="filterOption"
            @change="handleChange"
          >
            <a-select-option
              :value="item.name"
              v-for="item in list"
              :key="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <div class="textBox">
          <div class="text">注意事项：</div>
          <div class="text">1.请输入公司营业执照上的公司名称</div>
          <div class="text">2.切换后你的账号权益会取消</div>
        </div>
        <div class="btnBox">
          <div class="btn dis-cent">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
} from "ant-design-vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
  },
  name: "",
  data() {
    return {
      value: undefined,
      list: [],
    };
  },
  created() {},
  methods: {
    delClick(){
      this.$emit("show");
    },
    handleChange(value) {
      let on;
      for (let i = 0; i < this.qMoney.length; i++) {
        const e = this.qMoney[i];
        if (e.name == value) {
          on = i;
        }
      }
      this.qMoneyOn = on + 1;
      const newArray = this.removeElementsBeforeIndex(
        this.qMoney.slice(),
        on + 1
      );
      this.hMoney = newArray;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.bj {
  .content {
    background-color: #fff;
    border-radius: 10px;
    width: 400px;
    padding: 20px;
    .headBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        font-weight: 600;
        font-size: 18px;
      }
      .close {
        cursor: pointer;
      }
    }
    .inpBox {
      margin-top: 20px;
    }
    .textBox {
      padding-top: 40px;
      color: #4f6d92;
      .text{
        margin-top: 5px;
      }
    }
    .btnBox {
      margin-top: 80px;
      display: flex;
      justify-content: flex-end;
      .btn {
        width: 100px;
        background-color: #1277f3;
        height: 40px;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
